// extracted by mini-css-extract-plugin
export var actionIcon = "SquareCard-module--actionIcon--927cc";
export var body = "SquareCard-module--body--9522e";
export var cdsAssistiveText = "SquareCard-module--cds--assistive-text--09a2f";
export var cdsVisuallyHidden = "SquareCard-module--cds--visually-hidden--147eb";
export var darkMode = "SquareCard-module--darkMode--7fc7a";
export var disabled = "SquareCard-module--disabled--c077e";
export var helperIcon = "SquareCard-module--helperIcon--bef46";
export var helperText = "SquareCard-module--helperText--b0973";
export var hideFeedback = "SquareCard-module--hide-feedback--9c7d0";
export var showFeedback = "SquareCard-module--show-feedback--35a24";
export var skeleton = "SquareCard-module--skeleton--15ec8";
export var squareCard = "SquareCard-module--squareCard--87565";
export var title = "SquareCard-module--title--d266a";
export var titleSmall = "SquareCard-module--titleSmall--192dd";